import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Flame, Sparkles, Wind, Calendar, Filter, ChefHat, Pipette,
  ArrowRight, Fan,
} from "lucide-react";
import { SERVICES } from "@/data/services";

// Map icon name -> component
const ICONS = {
  Flame, Sparkles, Wind, AirVent: Wind, Fan, Calendar, Filter,
  ChefHat, Pipette, WindArrowDown: Wind,
};

export default function ServicesGrid({ title, subtitle }) {
  return (
    <section data-testid="services-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">
            Nos prestations
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#00367e] leading-[1.1]">
            {title || (<>10 services experts pour <span className="dh-underline">votre cuisine pro</span></>)}
          </h2>
          {subtitle && (
            <p className="mt-5 text-lg text-slate-700 max-w-2xl">{subtitle}</p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.45, delay: i * 0.05 }}
              >
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group block bg-white rounded-3xl p-7 border border-slate-100 shadow-[0_8px_30px_rgb(0,54,126,0.06)] hover:-translate-y-2 hover:shadow-[0_24px_50px_rgb(0,54,126,0.14)] hover:border-[#066ec4]/30 transition-all duration-300 h-full"
                >
                  <div className="w-14 h-14 rounded-2xl bg-[#f1f5fb] text-[#00367e] flex items-center justify-center mb-5 group-hover:bg-[#00367e] group-hover:text-white transition-colors">
                    <Icon size={26} strokeWidth={2.2} />
                  </div>
                  <h3 className="text-xl font-bold text-[#00367e] leading-snug">{s.title}</h3>
                  <p className="mt-3 text-slate-600 text-[15px] leading-relaxed">{s.short}</p>
                  <div className="mt-5 inline-flex items-center gap-1.5 text-[#066ec4] font-semibold text-sm">
                    En savoir plus <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
